import { openSnackbar } from "api/snackbar";

export const showNotification = (message, type = "success") => {
    openSnackbar({
        open: true,
        message: message || 'Server error, please try again later!',
        variant: 'alert',
        alert: {
            color: type === 'error' ? 'error' : type === 'success' ? 'success' : type === 'warning' ? 'warning' : 'info',
            variant: 'standard'
        },
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
        transition: 'SlideLeft',
        close: true
    });
};
